import { Component } from '@angular/core';
import { BigUntypedFormGroup } from '../../form-control/big-form-group';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
    selector: 'big-form-nested-values-base',
    template: '',
})
export class NestedValuesBaseComponent extends InputBaseComponent {
    // we declare control as FormControl in InputBaseComponent but here it is nested. therefore a FormGroup
    // can we have a better solution? Getters from InputBaseComponent but not the declare override?
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    declare public control?: BigUntypedFormGroup;
}
